module.exports = __webpack_public_path__ + "static/media/lock.76ceab8c.svg";